<template>
  <div class="wrapper blog-page">
    <div class="page-header page-header-small header-filter">
      <div
        class="page-header-image"
        style="background-image: url('img/about_bg.jpg');"
      ></div>
      <div class="content-center">
        <div class="row">
          <div class="col-md-6 mx-auto text-center">
            <h1 class="title text-white">
              Recent News
            </h1>
            <h3 class="lead mt-0 font-weight-500 text-white">
                {{ homepagedata.recentNews }}
            </h3>
            <!-- <base-button
              type="warning"
              icon="fa fa-twitter"
              rounded
              icon-only
            ></base-button>
            <base-button
              type="warning"
              icon="fa fa-instagram"
              rounded
              icon-only
            ></base-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <!-- latest events/blog -->
      <div
        class="section blogs-5 border-top border-bottom"
        style="background-image: url('img/ill/p31.svg');background-size: cover;"
        >
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-10 mx-auto">
              <div class="row">
                <div
                  class="col-lg-4 col-md-6"
                  v-for="news in newsData"
                  :key="news._id"
                >
                  <card class="card-blog card-plain">
                    <div class="card-image rounded-xl">
                      <a :href="'blog-post/' + news.blog_id">
                        <img class="img-fluid rounded-xl" :src="news.blog_img" />
                      </a>
                    </div>
                    <div class="card-body px-4">
                      <h5 class="card-title">
                        <a
                          :href="'blog-post/' + news.blog_id"
                          class="text-dark"
                          >{{ news.blog_title }}</a
                        >
                      </h5>
                      <!-- <p class="card-description" v-html="news.blog_body"></p> -->
                      <div class="card-footer">
                        <div class="author">
                          <!-- <img
                            src="img/faces/team-3.jpg"
                            alt="..."
                            class="avatar img-raised"
                          /> -->
                          <a
                            class="text-alpine"
                            :href="'blog-post/' + news.blog_id"
                            >Read <i class="fa fa-chevron-right fa-05x"></i
                          ></a>
                        </div>
                        <div class="stats stats-right opacity-8 text-white">
                          <i class="ni ni-watch-time"></i>
                          {{ dateformat(news.created_at) }}
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="social-line social-line-big-icons py-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-3 col-md-6 mb-md-4 mb-lg-0">
              <base-button
                tag="a"
                href="https://x.com/alpinekhurja"
                class="btn-icon btn-gradient-twitter"
                type=""
                target="_blank"
              >
                <i class="fa fa-twitter"></i>
                <p class="title">twitter</p>
                <p class="subtitle">@alpinekhurja</p>
              </base-button>
            </div>
            <div class="col-lg-3 col-md-6 mb-md-4 mb-lg-0">
              <base-button
                tag="a"
                href="https://www.facebook.com/APS.Kh2002/"
                class="btn-icon btn-gradient-facebook"
                type=""
                target="_blank"
              >
                <i class="fa fa-facebook"></i>
                <p class="title">facebook</p>
                <p class="subtitle">@APS.Kh2002</p>
              </base-button>
            </div>
            <div class="col-lg-3 col-md-6">
              <base-button
                tag="a"
                href="https://www.instagram.com/apskhurja"
                class="btn-icon btn-gradient-instagram"
                type=""
                target="_blank"
              >
                <i class="fa fa-instagram"></i>
                <p class="title">instagram</p>
                <p class="subtitle">@apskhurja</p>
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Parallax from "vue-parallaxy";
// import { Glide, GlideSlide } from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import axios from "axios";
import moment from "moment";
import Modal from "@/components/Modal.vue";

export default {
  bodyClass: "homepage",
  components: {
    // [Glide.name]: Glide,
    // [GlideSlide.name]: GlideSlide,
  },
  data() {
    return {
      animationObject: {
        classes: "fadeInLeft",
        delay: 500,
        duration: 1000,
      },
      metaData: [],
      openPopup: false,
      popupdata: {},
      newsData: [],
      testimonialData: [],
      headermenu: [],
      homepagedata: {},
      datanotfound: false,
      auth: {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "alpine#" + localStorage.getItem("accessToken"),
          _id: localStorage.getItem("_id"),
        },
      },
      authjson: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "alpine#" + localStorage.getItem("accessToken"),
          _id: localStorage.getItem("_id"),
        },
      },
    };
  },
  mounted() {
    if (
      localStorage.getItem("selectstore") == null ||
      localStorage.getItem("selectstore") == "undefined" ||
      localStorage.getItem("selectstore") == ""
    ) {
      this.selectstore = true;
      //localStorage.setItem('selectstore',false);
    }
    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "read_homepopup",
        { details: {}, offset: "0" },
        this.authjson
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.popupdata = response.data.details[0];
          if (this.popupdata.status === "approved") {
            this.openPopup = true;
          }
        }
      });
    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "read_homepage",
        { details: {}, offset: "0" },
        this.authjson
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.homepagedata = response.data.details[0];
        }
      });
    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "read_header_menu",
        { details: {}, offset: "0" },
        this.authjson
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.headermenu = response.data.details;
        }
      });

    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "read_blog_all",
        { details: {}, offset: "0" },
        this.authjson
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.newsData = response.data.details;
        } else {
          this.newsData = [];
        }
      });

    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + "read_testimonial",
        { details: {}, offset: "0" },
        this.authjson
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.testimonialData = response.data.details;
        } else {
          this.testimonialData = [];
        }
      });
    // read meta api call
    // axios
    // .post(process.env.VUE_APP_API_ENDPOINT+'read_metadata',{ "details" :{"page_url":'/'},"offset":"0"},this.authjson)
    // .then(response => {
    //   console.log(response);
    //   if(response.data.details){
    //   this.metaData=response.data.details[0];
    //   }else{
    //     this.metaData={};
    //   }
    // })
  },
  metaInfo() {
    return {
      title: this.metaData.meta_title,
      titleTemplate: "%s | Bakeneto",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
      meta: [
        {
          name: "description",
          content: this.metaData.meta_description,
        },
        {
          property: "og:title",
          content: this.metaData.og_title,
          // template: '%s - My page',
          template: (chunk) => `${chunk} - Bakeneto`,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: this.metaData.og_description,
          vmid: "og:description",
        },
        {
          property: "og:image",
          content: this.metaData.og_image,
          vmid: "og:image",
        },
        {
          property: "og:type",
          content: this.metaData.og_type,
          vmid: "og:type",
        },
        {
          property: "og:url",
          content: "https://bakeneto.com" + window.location.pathname,
          vmid: "og:url",
        },
      ],
    };
  },
  methods: {
    dateformat(val) {
      return moment.utc(new Date(val)).format("Do MMM YYYY");
      //console.log(this.blogData.date);
    },
    prev() {
      this.$refs.myCarousel.prev();
    },
    next() {
      this.$refs.myCarousel.next();
    },
  },
};

// export default {
//   bodyClass: "homepage",
//   components: {
//     // BCarousel,
//     // BCarouselSlide,
//     Parallax,
//     [Glide.name]: Glide,
//     [GlideSlide.name]: GlideSlide
//   },
//   data() {
//     return {
//       animationObject:{
//         classes: 'fadeInLeft',
//         delay: 500,
//         duration: 1000
//       }
//     };
//   },
// };
</script>
<style>
.blog-page .page-header .content-center {
    top: 60%;
}
.homepage .carousel {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.testimonials-3 .carousel {
  height: auto;
  margin-top: 0px;
}
.testimonials-3 .carousel-caption {
  right: 0%;
  top: 20px;
  left: 5%;
}
.testimonials-3 .carousel-control-prev,
.testimonials-3 .carousel-control-next {
  z-index: 9999;
}
.homepage {
  background-color: white;
}
.homepage .Masthead {
  z-index: 0;
}
.main-slides:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 250px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(35, 31, 32, 0.8)),
    to(rgba(35, 31, 32, 0))
  );
  background: linear-gradient(
    180deg,
    rgba(35, 31, 32, 0.8) 0%,
    rgba(35, 31, 32, 0) 100%
  );
  display: block;
}
.quick-video .card-background {
  padding: 50px 35px;
}
.principal {
  background-image: url(/img/school_kids.jpg);
  background-size: cover;
}
.main-video {
  object-fit: fill;
}
.video-tile {
  width: 340px;
  height: 200px;
}
.homepage .testimonials-3 .info .description {
  padding: 10px 0px;
}
.homepage .glide__slides .glide__slide img {
  margin: 0px auto;
}
.homepage .testimonials-3 .info .author img {
  margin-left: 0px;
  width: 68px;
}
.homepage .testimonials-3 .author {
  display: flex;
}
.testimonials-3 .positioned {
  z-index: 999;
}
@media (max-width: 768px) {
  .video-tile {
    width: 100%;
    height: auto;
  }
}
</style>
